import { createAsyncThunk, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AICodingClient, CreateAICodingJobCommand } from "app/ApiClient";
import { LoadingState } from "types";
import { AICodingState } from "./aiCodingState";
import { getDatasetRespondentsCount } from "slices/project/projectSlice";

const client = new AICodingClient(process.env.REACT_APP_API_URL);


export const createAICodingJob = createAsyncThunk(
  "aiCoding/createAICodingJob",
  async (data: CreateAICodingJobCommand, { rejectWithValue }) => {
    try {
      return await client.createAICodingJob(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addV1Reducers = (builder: ActionReducerMapBuilder<AICodingState>) => {
  builder
    .addCase(createAICodingJob.pending, (state) => {
      state.createAICodingJobState = LoadingState.pending;
    })
    .addCase(createAICodingJob.fulfilled, (state, action) => {
      state.createAICodingJobState = LoadingState.succeed;
      state.createdJobConfigId = action.payload.jobConfigId;
    })
    .addCase(createAICodingJob.rejected, (state) => {
      state.createAICodingJobState = LoadingState.failed;
    })
    .addCase(getDatasetRespondentsCount.pending, (state) => {
      state.variableStatsLoading = LoadingState.pending;
    })
    .addCase(getDatasetRespondentsCount.fulfilled, (state, action) => {
      state.variableStatsLoading = LoadingState.succeed;
      
      const datasetRespondents = action.payload;
      const existingCodedCount = state.variableItemVM?.stats.coded;

      const numberOfVariables = state.variableItemVM?.variableNames ? state.variableItemVM.variableNames.length : 0;
      const totalResponses = datasetRespondents * numberOfVariables;

      if (!totalResponses) {
        if (state.variableItemVM) {
          state.variableItemVM.stats = {
            total: 0,
            coded: 0,
            notCoded: 0,
          };
        }
        return;
      }
      
      if (state.variableItemVM) {
        state.variableItemVM.stats = {
          total: totalResponses ?? 0,
          coded: existingCodedCount,
          notCoded: existingCodedCount !== undefined
            ? Math.max((totalResponses ?? 0) - existingCodedCount, 0)
            : totalResponses ?? 0,
        };
      }
    })
    .addCase(getDatasetRespondentsCount.rejected, (state) => {
      state.variableStatsLoading = LoadingState.failed;
    });
}
